import React, { Component } from 'react'
import "./Heal.scss"
import DefaultLayout from "../layout/Default";

class Heal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            
        }
    }

    render() {
        return (
            <DefaultLayout>
               
            <div className="container has-text-left has-background-light all-of-it mt">
                <div className="big-heal has-text-centered">
                <img src="https://www.lush.ca/on/demandware.static/-/Library-Sites-LushSharedLibrary/default/dw9cc2f903/images/2017/July/4-top-tattoo-care-tips-in-line.jpg" alt=""/>
                </div>
                <br/>
                <div id="has-to-go">
<h1 className="title has-text-centered">How Do I Take Care of My Tattoo?</h1>

<h3 className="title is-5">How to care of a Tattoo? As you leave the parlor with your fresh new piece, this is the question you will find yourself asking.</h3>

<strong className="mt">Summary</strong>
<div class="content">
<ul>
    <li>Keep initial bandage covering your new tattoo on for at least two hours.</li>
    <li>Clean tattoo with antibacterial, no fragrance soap and hot water. Let air dry!</li>
    <li>Wash 2-3 times a day in the first two weeks of having your new tattoo.</li>
    <li>A&D, Aloe Vera lotion,Coconut oil, and others are great for a light moisturizing layer after cleaning.</li>
    <li>Do not use sunscreen to moisturize. Cover your new tattoo with clothing, and stay out of the sun.</li>
    <li>Do not itch or pick at your scabs and flakes!</li>
    <li>If you have severe pain, swelling, bleeding scabs, or continual plasma oozing, contact your artist and a doctor.</li>
</ul>
</div>

<div class="content has-background-white mt">
<ul>
    <li>Tattoo Aftercare Timetable</li>
    <li>Which Products Should I Use for Tattoo Aftercare?</li>
    <li>Can I Use Coconut Oil on My New Tattoo?</li>
    <li>What Should I Avoid in the Process of Tattoo Aftercare?</li>
    <li>What Are the Symptoms I Should Be Aware of in Regards to My New Tattoo?</li>
</ul>
</div>
<span className="mt"></span>
We know that tattoo aftercare is one of the most important aspects of the tattoo journey. Though, for some reason the tattoo community has had a hard time reaching a general agreement on how to properly care for a tattoo after being inked. With tens of thousands of parlors in the United States alone, you are likely to get different instructions from one artist studio to the next. The main reason why it’s so difficult to agree on a single solution is simply that tattoo aftercare has many solutions to it.
<span className="mt"></span>
The primary reason for this may lie in the many different standards for tattoo shops all over the world. Artists from the very same shop recommend different types of aftercare to their clients. Most artists even offer different aftercare instructions based on the location of the tattoo that their client has received (such as a tattoo on a foot getting different treatment than one on the arm). In this post, we will highlight the most important guidelines to keep your new piece looking shiny and clean. <br/>
<span className="mt"></span>


<h5 className="title has-text-centered">Tattoo Aftercare Timetable</h5>
Each and every tattoo will go through a healing process that typically lasts 2-4 weeks. Some collectors out there are blessed with forgiving skin, and their tattoos will heal with minimal upkeep and attention. Others are less fortunate, and their new tattoo will need to be kept under a close eye to ensure proper healing. The first week of healing is critical to how your tattoo will look for the rest of its life, so let’s have a look on how to take care of your new permanent accessory:

<div class="content mt">
<ul>
    <li>Keep the initial bandage on for a minimum of two hours.</li>
    <li>Your artist knows which length of time is best for you and your tattoo, so ensure you listen to their advice.</li>
    <li>After removing your bandage, you should gently cleanse your new tattoo with an antibacterial, fragrance-free soap (we like Dr. Bronner’s Hemp Baby Unscented, Pure-Castile Soap) and hot water. The hot water may cause temporary mild stinging, but will aid in opening pores and killing bacteria for maximum cleansing.
</li>
<li>For larger scale pieces, you will want to opt for a shower instead of a bath during this time. When you exit the shower, do NOT rub your tattoo with a towel. Let it dry on its own.
Keeping your tattoo clean and washing it 2-3 times daily will avoid a potential infection.</li>
</ul>
 </div>

<div className="has-text-centered mt">
<img src="https://tattoodo-web.imgix.net/guides/content/aftercare/artist-tattooing.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>You might get different instructions from different artists, there isn’t one solution for all. So listen to your artist’s instructions. 
</footer>
</div>
<span className="mt"></span>
<h5 className="title has-text-centered">Which Products Should I Use for Tattoo Aftercare?</h5>
<br/><br/>

Your new tattoo needs to breathe to promote the healing process — which is why most professional tattoo artists will recommend lotions, butters, or natural oils free of synthetic chemicals, ointments and fragrances that often clog and suffocate the pores and act as irritants to broken skin. The more organic and natural, the better for your tattoo. This brings us to our personal favorite healing method.
<div className="columns">
<div className="column">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/wrapping-tattoo.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
    <footer>Keep the initial bandage on for a minimum of two hours.
</footer>
</div>
<div className="column">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/apply-lotion.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
    <footer>For your tattoo to heal the best, it’s very important to use lotions, butters, or natural oils recommended by your tattoo artist.
</footer>
</div>
</div>

<h5 className="title has-text-centered mt">Can I Use Coconut Oil on My New Tattoo?</h5>
<span className="mt"></span>
Naturally antibacterial, antifungal, anticarcinogenic, antimicrobial, anti-inflammatory and free of synthetic chemicals (unlike most ingredients found on drugstore shelves) coconut oil has become an increasingly popular choice of aftercare for all skin types, especially those with hyper-sensitive skin.
<span className="mt"></span>

When applied, coconut oil forms a layer which aids in the protection from external bacteria, fungi, parasites, and dust. Its natural lipids speed up the healing process by repairing tissues damaged by the process of tattooing. <br/><br/>

<div className="has-text-centered mt">
<img src="https://tattoodo-web.imgix.net/guides/content/aftercare/coconut-oil.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>Coconut oil is great for moisturizing your new tattoo.
</footer>
</div>
<span className="mt"></span>

In the market for coconut oil — there’s a specific kind you would want to look for. Unrefined, virgin coconut oil is superior to the refined type as it is the most natural and nutrient dense, free from heat and chemical processing. <br/><br/>
The process of tattooing impedes our skin’s natural production of oil, which is why it is very important to moisturize your new tattoo regularly. There’s not an exact science to the amount of times you should be applying your aftercare. No matter what, it’s best to listen to your body. Whenever your tattoo is feeling particularly parched, or itchy — you can rub on a small amount of coconut oil. Keep in mind that coconut oil will take a bit longer to absorb, and a little goes a long way.

<h5 className="title mt">What Should I Avoid in the Process of Tattoo Aftercare?
</h5>

Sunblock and sunscreens are typically not formulated to protect wounds like a fresh tattoo. You will feel your fresh tattoo burning if it’s exposed to sunlight. If you must be out in the sun, keep it completely covered with sun-protective clothing at all times!

<div className="has-text-centered mt">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/woman-on-beach.jpg?auto=format%2Ccompress&fit=crop&w=500
" alt=""/>
<footer>After you get a new tattoo, one of the things to avoid is direct sunlight.
</footer>
</div>
<span className="mt"></span>
When clothing and fabric abrade against your new tattoo, you run the risk of agitating the healing process. The least amount of contact with fabric is usually the best call while healing a new tattoo. Loose-fitting clothing should be worn around the area for a week minimum. After a solid 2-3 weeks, you can probably wear your tight clothing again like the picture above.
<span className="mt"></span>
While in the healing phase, it is common for your tattoo to seep excess plasma, fluid, and ink — which may stick to sheets, blankets, or clothing. If you can sleep with your tattoo exposed, that would be best. To be safe, you can place a clean thin towel between you and the sheets. If in the morning your tattoo is stuck to fabric, this is no cause for alarm. Don’t peel it off! Instead, take the fabric with you to the shower and wet it off with cool or lukewarm water.

<div className="has-text-centered mt">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/woman-reading.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>Avoid sleeping on your fresh tattoo and cover your bed with clean towels.
</footer>
</div>
<span className="mt"></span>>
Scabbing is a very normal part of the tattoo healing process. <b>DO NOT PICK THE SCAB</b>. Don’t scrub it either. Scabbing will typically be the same color as the pigment that was used. If you pick or scrub your scab, you risk pulling out the color or causing hypertrophic scarring of your tattoo. Let the tattoo heal by itself. Patience is a virtue.


<div className="has-text-centered mt">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/itchy-tattoo.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>If your tattoo itches, don’t scratch it!
</footer>
</div>
<span className="mt"></span>
Opt for showers instead of baths for 2-3 weeks as submerging a new tattoo in standing water may expose open skin to unwanted bacteria. This means no baths, pools, jacuzzis, lakes, ponds or quick dips in the ocean.


<div className="has-text-centered mt">
    <img src="https://tattoodo-web.imgix.net/guides/content/aftercare/milk-bath.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>Avoid standing water that may expose open skin to unwanted bacterias.

</footer>
</div>

<h4 className="title mt">What Are the Symptoms I Should Be Aware of in Regards to My New Tattoo?</h4>
<span className="mt"></span>
Some symptoms might raise concerns when it comes to your new tattoo. You don’t have to be worried about every single signal your body emits, but a few of them should alarm you.
<span className="mt"></span>
If you’ve noticed a sudden outbreak of pimples around your tattoo, chances are you’ve over moisturized. Dial back on the oil/lotion and try to maintain a moisture level even with the rest of your body.

Professional tattoo artists do everything possible to ensure safe tattooing practices. However, they are not medical professionals. Contact your doctor immediately if the following symptoms arise when you’ve gotten a new tattoo:
<div class="content">
<ul>
    <li>Severe pain or swelling
</li>
    <li>Prolonged oozing of plasma with or without color
</li>
    <li>Thick, hard scabs that are bleeding red blood
</li>
</ul>
</div>
So, there you have it. By following this aftercare advice your brand new tattoo will soon mature into a phenomenally healed tattoo. Admittedly this is a lot to do, but considering that you’re going to have that same tattoo for the rest of your life, what does it actually mean that you have to pay close attention to the aftercare for a couple of weeks?

Book now

            </div>
            </div>
            </DefaultLayout>
        )
    }
}

export default Heal
